module.exports = __webpack_public_path__ + "Flama-MediumItalic.woff2?54d1016bd4cb9181eb774ab28b16cf47";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-MediumItalic.woff2
// module id = 890
// module chunks = 0